export default (function (e) {
  return e && "string" == typeof e && encodeURIComponent(e).replace(/[!'()*]/g, function (e) {
    return "%" + e.charCodeAt(0).toString(16);
  });
});